import styled from 'styled-components';

export const Title = styled.h5`
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: rgba(39, 42, 50, 1);
  margin: 0;
`;
export const AdditionalInfo = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0;
  color: rgba(146, 151, 162, 1);
`;

export const MainToastWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ToastTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ToastRightWrapper = styled.div`
  display: flex;
  margin-right: 16px;
`;

export const ToastLeftWrapper = styled.div`
  display: flex;
  gap: 16px;
`;
